// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  makeIt1 = false;
  constructor(private readonly router: Router, private readonly storageService: StorageService){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      const roles = this.storageService.secureStorage.getItem('currentUserRoles');      
      roles.forEach((role:string) => {
        if(route.data?.allowedRoles.includes(role.toLowerCase())){
          this.makeIt1 = true;        
        }
      });
      if(!this.makeIt1){
        this.router.navigate(['/404']);
      }
      return this.makeIt1;
  }
  
}

export const IsAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthguardService).canActivate(route, state);
}
